import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    getLoggedInUser: null,
    getCurrentUserPermission: null,
    companyCode: null,
    planFeatures: null,
  },
  plugins: [createPersistedState()],
  mutations: {
    GET_CURRENTLY_LOGGED_IN_USER(state, getLoggedInUser) {
      state.getLoggedInUser = getLoggedInUser;
    },
    GET_CURRENT_LOGGED_IN_USER_PERMISSION(state, getCurrentUserPermission) {
      state.getCurrentUserPermission = getCurrentUserPermission;
    },
    SET_COMPANY_CODE(state, code) {
      state.companyCode = code;
    },
    SET_PLAN_FEATURES(state, features) {
      state.planFeatures = features;
    },
  },
  actions: {
    getCurrentUser: ({ commit }, getLoggedInUser) =>
      commit('GET_CURRENTLY_LOGGED_IN_USER', getLoggedInUser),
    getCurrentUserPermission: ({ commit }, getCurrentUserPermission) =>
      commit('GET_CURRENT_LOGGED_IN_USER_PERMISSION', getCurrentUserPermission),
    setCompanyCode: ({ commit }, code) =>
      commit('SET_COMPANY_CODE', code),
    setPlanFeatures: ({ commit }, features) =>
      commit('SET_PLAN_FEATURES', features),
  },
})
